export default "__VITE_ASSET__Cl$wkwZw__"